import styled from '@emotion/styled';

import colors from 'config/theme/colors';

export const Icon = styled.i`
  color: ${colors['@btn-default-border']};
  font-size: 12px;
  margin-right: 16px;
`;
